<template>
  <div>
    <el-dialog
      title="选择定制采购单行项目"
      :visible="show"
      width="1000px"
      @close="close"
    >
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="400px"
        v-loading="loading"
      >
        <el-table-column
          prop="commodityName"
          label="商品信息"
          min-width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content" style="max-width: 300px">
                  <p>
                    商品名称：{{
                      scope.row.relatedCustomizeOrderItem.commodityName
                    }}
                  </p>
                  <p class="fm-mt-5">
                    备注：
                    <span
                      v-fmtype="
                        scope.row.relatedCustomizeOrderItem.remark
                          ? ''
                          : 'warning'
                      "
                      >{{
                        scope.row.relatedCustomizeOrderItem.remark || "——"
                      }}</span
                    >
                  </p>
                </div>
                <div>
                  <p class="fm-line-2">
                    商品名称：{{
                      scope.row.relatedCustomizeOrderItem.commodityName
                    }}
                  </p>
                  <p class="fm-line-2 fm-mt-5">
                    备注：
                    <span
                      v-fmtype="
                        scope.row.relatedCustomizeOrderItem.remark
                          ? ''
                          : 'warning'
                      "
                      >{{
                        scope.row.relatedCustomizeOrderItem.remark || "——"
                      }}</span
                    >
                  </p>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="相关图片"
          width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.relatedCustomizeOrderItem.fileList &&
                scope.row.relatedCustomizeOrderItem.fileList.length > 0
              "
            >
              <el-image
                v-for="(item, index) in scope.row.relatedCustomizeOrderItem
                  .fileList"
                :key="index"
                :style="{
                  width: '45px',
                  height: '45px',
                  'border-radius': '5px',
                  border: '1px solid var(--fm-border-color)',
                  'margin-left': '5px',
                }"
                fit="cover"
                :preview-src-list="
                  scope.row.relatedCustomizeOrderItem.fileList.map(
                    (d) => d.sysFile.prefix + d.sysFile.name
                  )
                "
                :src="item.sysFile.prefix + item.sysFile.name"
              ></el-image>
            </div>
            <div class="fm-center" v-else>
              <p v-fmtype="'warning'">暂未上传</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="入库进度"
          width="150"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ "待入库 " + scope.row.toBeInputQuantity }}<br />
            {{
              "入库中 " +
              scope.row.inputingQuantity +
              " , 已入库 " +
              scope.row.completedInputQuantity
            }}<br />
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-document"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="选择定制采购单行项目"
      :visible="editItemPopupShow"
      width="600px"
      @close="editItemPopupShow = false"
      v-if="editItemPopupShow"
    >
      <p>
        商品：{{
          editItem.relatedCustomizePurchaseOrderItem.relatedCustomizeOrderItem
            .commodityName
        }}
      </p>
      <p>
        备注：{{
          editItem.relatedCustomizePurchaseOrderItem.relatedCustomizeOrderItem
            .remark
        }}
      </p>
      <el-divider></el-divider>
      <el-form ref="form" :model="editItem" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item style="margin-bottom: 0" label="采购单价">
              <FmAmount
                :amount="editItem.relatedCustomizePurchaseOrderItem.retailPrice"
              ></FmAmount>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="margin-bottom: 0" label="购买数量">
              {{
                editItem.relatedCustomizePurchaseOrderItem.itemQuantity +
                " " +
                editItem.relatedCustomizePurchaseOrderItem
                  .relatedCustomizeOrderItem.unit
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="入库进度">
          <div style="line-height: 1.3em; padding: 7px 0">
            <p class="fm-flex">
              待入库
              {{
                editItem.relatedCustomizePurchaseOrderItem.toBeInputQuantity
              }}，入库中
              {{ editItem.relatedCustomizePurchaseOrderItem.inputingQuantity }}
            </p>
            <p class="fm-flex">
              已入库
              {{
                editItem.relatedCustomizePurchaseOrderItem
                  .completedInputQuantity
              }}
            </p>
          </div>
        </el-form-item>
        <template v-if="from == 'CustomizeInputOrder'">
          <el-divider></el-divider>
          <el-form-item label="入库数量" prop="itemQuantity">
            <CommodityQuantityInputBox
              style="width: 200px"
              :key="'itemQuantityInputNumber' + itemQuantityKey"
              label="数量"
              v-model="editItem.itemQuantity"
              size="mini"
              :max="
                editItem.relatedCustomizePurchaseOrderItem.toBeInputQuantity
              "
              @change="
                (e) => {
                  changeItemQuantityFromList(
                    e,
                    selectList.findIndex((d) => d.itemNo == editItem.itemNo),
                    true
                  );
                }
              "
            ></CommodityQuantityInputBox>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editItemCancel">取 消</el-button>
        <el-button type="primary" @click="editItemConfirm">选 择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomizePurchaseOrderItemSelectDialog",

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    from: {
      //  来源，CustomizeInputOrder 定制入库单
      type: String,
      default: null,
      require: true,
    },
    supplierId: {
      type: String,
      default: null,
      require: true,
    },
    customizePurchaseOrderId: {
      type: String,
      default: null,
      require: true,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.getOrderInfo();
        this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,

      editItemPopupShow: false,
      // 当前选择的item
      editItem: {},

      // 显示已选商品弹窗
      showSelectListPopup: false,

      itemQuantityKey: "null",
      itemList: [],

      quantityMinLimit: 0.001,
    };
  },

  mounted() {},

  methods: {
    close() {
      this.$emit("close");
    },

    select(item) {
      // CustomizePurchaseOrder 定制采购单 | CustomizeOutputOrder 定制出库单
      if (item.toBeInputQuantity <= 0) {
        this.$message({
          message: "所选定制采购单行项目待入库数量为 0 ，请选择其他行项目",
          type: "error",
        });
        return;
      }

      let index = this.selectList.findIndex(
        (d) => d.relatedOrderItemId == item.id
      );
      if (index > -1) {
        this.editItem = JSON.parse(JSON.stringify(this.selectList[index]));
      } else {
        let itemNo =
          this.selectList && this.selectList.length > 0
            ? this.selectList[this.selectList.length - 1].itemNo + 1
            : 1;
        this.editItem = {
          itemNo: itemNo,
          relatedOrderItemId: item.id,
          relatedCustomizePurchaseOrderItem: item,
          itemQuantity: 1,
        };
      }
      this.editItemPopupShow = true;
    },
    editItemCancel() {
      this.editItemPopupShow = false;
      this.editItem = {};
    },
    editItemConfirm() {
      if (!this.editItem || !this.editItem.itemNo) {
        this.$message.error("请选择商品");
        return;
      }
      if (!this.editItem.itemQuantity) {
        this.$message.error("请输入数量");
        return;
      }
      this.loading = true;
      try {
        let index = this.selectList.findIndex(
          (d) => d.relatedOrderItemId == this.editItem.relatedOrderItemId
        );
        if (
          this.editItem.itemQuantity >
          this.editItem.relatedCustomizePurchaseOrderItem.toBeInputQuantity
        ) {
          this.$message({
            message:
              "入库总数量不得大于所选商品的待入库数量" +
              this.editItem.relatedCustomizePurchaseOrderItem.toBeInputQuantity,
            type: "error",
          });
          return;
        }
        if (index > -1) {
          this.selectList.splice(index, 1, this.editItem);
        } else {
          this.selectList.push(this.editItem);
        }
        this.editItemPopupShow = false;
        this.$emit("selectCustomizePurchaseOrderItem", this.selectList || []);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (!this.editItemPopupShow) {
          this.$emit("close");
        }
      }
    },
    changeItemQuantityFromList(value, index) {
      // 如果index < 0，则代表是新商品，无需进行处理
      if (index < 0) {
        return;
      }
      if (value <= 0) {
        let that = this;
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            try {
              this.editItem = {};
              this.editItemPopupShow = false;
              this.selectList.splice(index, 1);
              this.$emit(
                "selectCustomizePurchaseOrderItem",
                this.selectList || []
              );
            } finally {
              if (!this.editItemPopupShow) {
                this.$emit("close");
              }
            }
          })
          .catch(() => {
            this.editItem.itemQuantity = this.quantityMinLimit;
          });
      }
    },
    async getOrderInfo(args) {
      this.loading = true;
      let res = await this.$api.customizePurchaseOrder_findVoById(
        this.customizePurchaseOrderId,
        args
      );
      if (res && res.success) {
        this.itemList = res.data.itemList;
      }
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 解决分割线存在粗细不一致异常 */
.el-divider {
  background-color: transparent;
  position: relative;
}

.el-divider--horizontal {
  height: 0;
  border-bottom: 1px solid #dcdfe6;
}
</style>


// WEBPACK FOOTER //
// src/components/CustomizePurchaseOrderItemSelectDialog.vue